import { render, staticRenderFns } from "./DuplicateDeliverableListItem.vue?vue&type=template&id=1e51edc4&scoped=true&"
import script from "./DuplicateDeliverableListItem.vue?vue&type=script&lang=js&"
export * from "./DuplicateDeliverableListItem.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDeliverableListItem.vue?vue&type=style&index=0&id=1e51edc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e51edc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e51edc4')) {
      api.createRecord('1e51edc4', component.options)
    } else {
      api.reload('1e51edc4', component.options)
    }
    module.hot.accept("./DuplicateDeliverableListItem.vue?vue&type=template&id=1e51edc4&scoped=true&", function () {
      api.rerender('1e51edc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/duplication/DuplicateDeliverableListItem.vue"
export default component.exports